import React, { useState } from 'react';
import { Paper, IconButton, InputBase, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SearchAuctionModal from '../feature/search-auction-modal';
import { useSelector, useDispatch } from 'react-redux';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { AUCTION_TYPE, NUMBER } from '../../constants/app-constants';
import { getAuctionsList, setSearchFlag } from '../../store/auctions/action';

// eslint-disable-next-line react/prop-types
const SearchBar = ({ eligibleForBid }) => {
    const { isSearchResults, type = AUCTION_TYPE.LIVE } = useSelector(state => state?.auctions);
    const [showSearchModal, setShowSearchModal] = useState(false);
    const dispatch = useDispatch();

    const handleClear = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (eligibleForBid) {
            const payload = { page: NUMBER.ZERO, size: NUMBER.TEN, section: type };
            dispatch(setSearchFlag(false));
            dispatch(getAuctionsList(payload));
        }
    };

    return (
        <React.Fragment>
            <Paper
                component="form"
                sx={{ display: 'flex', alignItems: 'center', width: 240 }} onClick={setShowSearchModal.bind(null, true)}
            >
                <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                    <SearchIcon />
                </IconButton>
                <InputBase
                    sx={{ flex: 1, fontSize: 11 }} readOnly value={isSearchResults ? isSearchResults : ''}
                    placeholder="make, model or app id" endAdornment={isSearchResults ? <InputAdornment onClick={handleClear} position="start">
                        <CloseOutlinedIcon />
                    </InputAdornment> : null}
                    inputProps={{ 'aria-label': 'Make, model or app id' }}
                />
            </Paper>
            {showSearchModal && <SearchAuctionModal eligibleForBid={eligibleForBid} handleClose={setShowSearchModal.bind(null, false)} />}
        </React.Fragment>
    );
};

export default SearchBar;
